import { createFileRoute } from '@tanstack/react-router';
import { formStepsSearchSchema } from '@/components/form/FormStepsPage';
import { CreatePrestationParticipationPage } from '@/features/prestation-participations/components/CreatePrestationParticipationPage';

export const Route = createFileRoute('/$commiteeSlug/prestation-participations/create')({
  component: CreatePrestationParticipationPage,
  validateSearch: formStepsSearchSchema,
});
